import React, { useState, useEffect } from "react";
import { API_BASE, ORIGIN_BASE } from "./config"; // ← EKLENDİ

// /uploads/... parçasını ayıkla (mutlak ya da relative olabilir)
const extractUploadsPath = (u) => {
  if (!u) return null;
  const m = String(u).match(/\/uploads\/[^?#)'"\\\s]+/i);
  return m ? m[0] : null;
};

// Önizleme için: relative → tam URL; localhost vb. mutlak URL → ORIGIN_BASE ile normalize
const toPublicUrl = (u) => {
  if (!u) return null;
  // Zaten /uploads/... ise ORIGIN_BASE ile birleştir
  if (u.startsWith("/uploads/")) return `${ORIGIN_BASE}${u}`;
  // http(s) olsa bile /uploads/... parçasını çekip ORIGIN_BASE ile birleştir
  const part = extractUploadsPath(u);
  if (part) return `${ORIGIN_BASE}${part}`;
  // başka bir mutlak URL ise dokunma
  return u;
};

// DB'ye kaydetmek için: her şeyi /uploads/... formuna indir
const toRelative = (u) => {
  if (!u) return u;
  if (u.startsWith("/uploads/")) return u;
  const part = extractUploadsPath(u);
  return part || u;
};

const ResimUpload = ({ onUpload, defaultPreview = null, label = "📤 Görsel Yükle",   mode = "image" // 👈 image | file
 }) => {
  const [preview, setPreview] = useState(defaultPreview ? toPublicUrl(defaultPreview) : null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPreview(defaultPreview ? toPublicUrl(defaultPreview) : null);
  }, [defaultPreview]);

  const handleFileChange = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file); // backend 'file' bekliyor

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE}/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }, // FormData için Content-Type ekleme
        body: formData,
      });

      const data = await res.json(); // { url: '/uploads/xxx.jpg' } veya mutlak URL
      const relative = toRelative(data?.url);
      setPreview(toPublicUrl(relative)); // önizleme TAM adres
      onUpload(relative);                // DB'ye RELATIVE kaydet
    } catch (err) {
      console.error("❌ Görsel yüklenemedi:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      <label
        style={{
          display: "inline-block",
          padding: "0.5rem 1rem",
          backgroundColor: "#2563eb",
          color: "#fff",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "0.9rem",
        }}
      >
        {label} {/* ← dil destekli */}
        
<input
  type="file"
accept={
  mode === "image"
    ? "image/png,image/jpeg,image/jpg,image/webp"
    : mode === "file"
      ? ".pdf,.doc,.docx,.xls,.xlsx,.zip"
      : "image/png,image/jpeg,image/jpg,image/webp,.pdf,.doc,.docx,.xls,.xlsx,.zip"
}

  onChange={handleFileChange}
  style={{ display: "none" }}
/>

      </label>

      {loading && <p style={{ marginTop: 8 }}>Yükleniyor...</p>}

   {preview && mode === "image" && (
     <div style={{ marginTop: 10 }}>
       <img
         src={preview}
         alt="Önizleme"
         style={{
           maxWidth: "100%",
           maxHeight: 150,
           borderRadius: "8px",
           boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
           border: "1px solid #ccc",
         }}
       />
     </div>
   )}
    </div>
  );
};


export default ResimUpload;
